export enum ConsultantHeaderContent {
  none,
  consultantWidget,
  consultantBanner,
}
